import { TAction } from './types/action';
import { IPushTopicSubscription } from '../services/pushNotificationApiService';

// Action Types
export const SET_PUSH_PERMISSION_STATE = 'SET_PUSH_PERMISSION_STATE';
export const SET_PUSH_SUPPORTED = 'SET_PUSH_SUPPORTED';
export const SET_PUSH_SUBSCRIPTION = 'SET_PUSH_SUBSCRIPTION';
export const SET_PUSH_TOPICS = 'SET_PUSH_TOPICS';
export const SET_PUSH_LOADING = 'SET_PUSH_LOADING';
export const SET_PUSH_ERROR = 'SET_PUSH_ERROR';
export const SET_PUSH_LINKED = 'SET_PUSH_LINKED';
export const ADD_PUSH_TOPIC = 'ADD_PUSH_TOPIC';
export const REMOVE_PUSH_TOPIC = 'REMOVE_PUSH_TOPIC';
export const SET_PUSH_INITIALIZED = 'SET_PUSH_INITIALIZED';
export const RESET_PUSH_STATE = 'RESET_PUSH_STATE';

// Payload Types
export interface IPushSubscriptionState {
  id: number;
  isLinked: boolean;
}

// Action Creator
const PushNotificationActionCreator = {
  setPermissionState(state: NotificationPermission): TAction<NotificationPermission> {
    return {
      type: SET_PUSH_PERMISSION_STATE,
      payload: state
    };
  },

  setInitialized(isInitialized: boolean): TAction<boolean> {
    return {
      type: SET_PUSH_INITIALIZED,
      payload: isInitialized
    };
  },

  setSupported(isSupported: boolean): TAction<boolean> {
    return {
      type: SET_PUSH_SUPPORTED,
      payload: isSupported
    };
  },

  setSubscription(subscription: IPushSubscriptionState | null): TAction<IPushSubscriptionState | null> {
    return {
      type: SET_PUSH_SUBSCRIPTION,
      payload: subscription
    };
  },

  setTopics(topics: IPushTopicSubscription[]): TAction<IPushTopicSubscription[]> {
    return {
      type: SET_PUSH_TOPICS,
      payload: topics
    };
  },

  setLoading(isLoading: boolean): TAction<boolean> {
    return {
      type: SET_PUSH_LOADING,
      payload: isLoading
    };
  },

  setError(error: string | null): TAction<string | null> {
    return {
      type: SET_PUSH_ERROR,
      payload: error
    };
  },

  setLinked(isLinked: boolean): TAction<boolean> {
    return {
      type: SET_PUSH_LINKED,
      payload: isLinked
    };
  },

  addTopic(topic: IPushTopicSubscription): TAction<IPushTopicSubscription> {
    return {
      type: ADD_PUSH_TOPIC,
      payload: topic
    };
  },

  removeTopic(topic: string): TAction<string> {
    return {
      type: REMOVE_PUSH_TOPIC,
      payload: topic
    };
  },

  reset(): TAction<void> {
    return {
      type: RESET_PUSH_STATE,
      payload: undefined
    };
  }
};

export default PushNotificationActionCreator;
